import React from 'react'
import { useSelector } from 'react-redux'

const Header = () => {

  const { cityData } = useSelector(state => state.CityWiseIplReducer)

  return (
    <div className='header-ipl'>
      {cityData?.city_image && <img src={require(`../../assets/${cityData?.city_image}`)} alt={cityData?.alt} loading="lazy" />}
    </div>
  )
}

export default Header
